import { Box3, Vector3 } from "three";

import { type Bounds, type Square, fileOf, rankOf, square } from "src/api";

export function squareToWorld(square: Square): Vector3 {
  return new Vector3(fileOf(square), 0, -rankOf(square));
}

export function worldToSquare(position: Vector3): Square {
  return square(Math.round(position.x), Math.round(-position.z));
}

// INFO: rotation needed for a vector pointing +X to point from one square to another
export function rotationFromSquareToSquare(from: Square, to: Square): number {
  const offset = squareToWorld(to).sub(squareToWorld(from));
  return Math.atan2(-offset.z, offset.x);
}

// the outer edges of the tiles since a square's world position is its center
export function boundsToBox(bounds: Bounds): Box3 {
  return new Box3(
    new Vector3(bounds.minFile - 0.5, 0, -bounds.maxRank - 0.5),
    new Vector3(bounds.maxFile + 0.5, 0, -bounds.minRank + 0.5)
  );
}
